import { GridFilterOperator } from '@mui/x-data-grid-pro'

import { GetQualificationResponse } from '@tabeeb/contracts/microservices/swagger-certificate-service'

import { UserSearchTs } from '@tabeeb/modules/shared/UserSearch'
import { UserSearchInfoResponse } from '@tabeeb/contracts/main-api/swagger-main-api'

const UserGridFilterOperator: GridFilterOperator<GetQualificationResponse>['InputComponent'] = ({
  item,
  applyValue,
  disabled,
}) => {
  return (
    <UserSearchTs
      size='small'
      disabled={disabled}
      freeSolo={false}
      multiple
      value={(item.value ?? []) as UserSearchInfoResponse[]}
      getOptionLabel={(option) => option.Email!}
      onChange={(event, value) => {
        applyValue({ ...item, value })
      }}
    />
  )
}

export default UserGridFilterOperator
